var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger","depressed":"","tile":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("Close")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }